/* global window */

import Vue from 'vue';
import $ from 'jquery';
import debounce from 'lodash/debounce';
import bind from 'lodash/bind';
import get from 'lodash/get';

import { RestComponent } from '../mixins/rest-component';
import './Events.scss';
import template from './Events.vhtml';

export default {
	name: 'Events',
	mixins: [RestComponent],
	template: template,
	props: {
		includes: {
			type: [Number, String],
			default: '',
		},
		amount: {
			type: Number,
			default: 8,
		},
		categories: {
			type: [Number, String],
			default: '',
		},
		search: {
			type: String,
			default: '',
		},
		topics: {
			type: [Number, String],
			default: '',
		},
		resultsAsGrid: {
			type: Boolean,
			default: false,
		},
		isBlue: {
			type: Boolean,
			default: false,
		},
		hasFetchMore: {
			type: Boolean,
			default: false,
		},
		autofill: {
			type: Boolean,
			default: false,
		},
		removeexpired: {
			type: Boolean,
			default: true,
		},
		showonlyselected: {
			type: Boolean,
			default: false,
		},
		type: {
			type: String,
			default: 'ALL',
			validator: value => ['ALL', 'BUSINESS', 'STUDENT'].indexOf(value) !== -1,
		},
	},
	data: () => ({
		events: [],
		isFetching: false,
		noResults: false,
		showMore: false,
		number: 8,
		params: {
			includes: '',
			event_search_str: '',
			category: '',
			topics: '',
			type: '',
			per_page: 8,
			page: 1,
			lang: 'da',
			autofill: false,
			removeexpired: true
		},
	}),
	computed: {
		showFetchMore: vm => vm.hasFetchMore && vm.showMore,
		eventsClasses: vm => {
			let dynamicClasses = {
				'events--bg-blue': vm.isBlue,
			};

			return ['events', dynamicClasses];
		},
		resultsWrapperClasses: vm => {
			let dynamicClasses = {
				'events__results-wrapper--min-height': vm.events.length === 0,
			};

			return ['events__results-wrapper', dynamicClasses];
		},
		resultClasses: vm => {
			let dynamicClasses = {
				'events__result--width-50perc-from-md': vm.resultsAsGrid,
			};

			return ['events__result', dynamicClasses];
		},
		dividerClasses: vm => {
			let dynamicClasses = {
				'o-divider--white': vm.isBlue,
			};

			return [
				'o-divider o-divider--ghosted o-divider--vertical',
				dynamicClasses,
			];
		},
	},
	watch: {
		// Commented out due to no this.search defined which lead to errors
		search() {
			Vue.set(this.params, 'event_search_str', this.search);
			this.reload();
		},
		topics() {
			Vue.set(this.params, 'topics', this.topics);
			this.reload();
		},
	},
	methods: {
		setupPlaceholder(str) {
			return `${str}...`;
		},
		fetchMore() {
			this.$options.fetchMore();
		},
		reload() {
			this.$options.reload();
		},
		isEven(num) {
			return num % 2;
		},
		eventLinkClasses(index) {
			let dynamicClasses = {
				'event-link--blue': this.isBlue && !this.isEven(index),
				'event-link--lighter-bg': this.isBlue && this.isEven(index),
			};

			return ['event-link', dynamicClasses];
		},
	},
	created() {
		// Create debounce versions of fetchMore and reload
		this.$options.fetchMore = debounce(bind(fetchMore, this), 500);
		this.$options.reload = debounce(bind(reload, this), 500);
	},
	mounted() {
		const params = this.getAllUrlParams();
		this.number = this.amount;
		this.params = { ...this.params, ...params };
		Vue.set(
			this.params,
			'per_page',
			this.hasFetchMore ? this.number + 1 : this.number
		);
		Vue.set(this.params, 'includes', this.includes);
		Vue.set(this.params, 'lang', window.siteData.language);
		Vue.set(this.params, 'category', this.categories);
		Vue.set(this.params, 'type', this.type);
		Vue.set(this.params, 'autofill', this.autofill);
		Vue.set(this.params, 'removeexpired', this.removeexpired);

		this.$nextTick(() => {
			this.reload();
		});
	},
};

function fetchMore() {
	// this.params.page++;
	const moreNumber = this.number + this.amount;
	this.number = moreNumber;

	Vue.set(
		this.params,
		'per_page',
		this.hasFetchMore ? this.number + 1 : this.number
	);

	this.isFetching = true;
	getItems(this.params)
		.then(result => {

			if (typeof result != 'object') {
				result = JSON.parse(result)
			}

			let events = get(result, 'data', []);
			// We use the +one method to determine if there are more events to show
			if (events.length > this.number) {
				this.showMore = true;
				events = events.slice(0, this.number);
			} else {
				this.showMore = false;
			}
			this.events = events;
		})
		.always(() => {
			this.isFetching = false;
			if (this.events.length === 0) {
				this.noResults = true;
			} else {
				this.noResults = false;
			}
		});
}

function reload() {
	//trackSearch(this.filters);
	this.number = this.amount;
	this.params.page = 1;
	this.isFetching = true;

	getItems(this.params)
		.then(result => {

			if (typeof result != 'object') {
				result = JSON.parse(result)
			}

			let events = get(result, 'data', []);
			// We use the +one method to determine if there are more events to show
			if (events.length > this.number) {
				this.showMore = true;
				events = events.slice(0, this.number);
			} else {
				this.showMore = false;
			}
			this.events = events;
		})
		.always(() => {
			this.isFetching = false;
			if (this.events.length === 0) {
				this.noResults = true;
			} else {
				this.noResults = false;
			}
		});
}

/**
 * Gets resumes from WP REST API
 *
 * @param {string} post_type
 * @param {string} [search=""]
 * @returns {JQueryPromise<any>}
 */
function getItems(params) {
	return $.get(`/wp-json/be/v1/events`, params);
}
